import { TranslationKey } from './../../../types/translation/TranslationKey';
import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import ContactOverviewPane from './Contact/ContactOverviewPane';
import OrderOverviewPane from './Order/OrderOverviewPane';
import { CompanyContext } from '../../../context/CompanyContext';
import { testIds } from '../../../util/identifiers/identifiers.util';
import { t } from '../../../types/translation/Translator';
import Pane from '../../../VentoryUI/components/common/Pane';
import UpdateContactPane from './Contact/Panes/UpdateContactPane';
import UpdateOrderPane from './Order/Panes/UpdateOrderPane';
import OrderSettingsScreen from './Order/Settings/OrderSettingsScreen';
import { Routing } from '../../../util/routes.util';
import Provider from '../../../providers/common/Provider';

export default function OperationScreen() {
  const { currentCompany } = useContext(CompanyContext);

  const orderFeatureToggles = currentCompany.settings.featureToggles.orders;

  const tabs = [
    {
      text: t(TranslationKey.order).plural.label,
      path: Routing.operations.orders.overview(),
      key: 'orders',
      shown: true,
    },
    {
      text: t(TranslationKey.contacts).singular.label,
      path: Routing.operations.contacts.overview(),
      key: 'contacts',
      shown: orderFeatureToggles.customer || orderFeatureToggles.supplier,
    },
  ].filter(tab => tab.shown);

  return (
    <OperationScreenProvider>
      <Routes>
        <Route path='orders/update/:id/*' element={<UpdateOrderPane />} />
        <Route path='orders/settings/*' element={<OrderSettingsScreen />} />

        <Route path='contacts/update/:id/*' element={<UpdateContactPane />} />
        <Route
          path='*'
          element={
            <Pane tabs={tabs} testId={testIds.operationScreen}>
              <Routes>
                <Route path='orders' element={<OrderOverviewPane />} />

                <Route path='contacts' element={<ContactOverviewPane />} />
              </Routes>
            </Pane>
          }
        />
      </Routes>
    </OperationScreenProvider>
  );
}

function OperationScreenProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider
      asset
      assetTransaction
      barcodeExportConfiguration
      bin
      binConstraint
      binStatus
      contact
      container
      containerType
      csvUploadConfiguration
      customField
      order
      file
      handlingUnit
      orderExportConfiguration
      pdfTemplate
      product
      productMasterData
      productTransaction
      stockLocation
      stockLocationRoleAssignment
      lot
      tag
      tagRelation
      user
      kitTemplates
      kit
      tableSettings
      orderFlows
      orderStatus
      productTransactionStatus
    >
      {children}
    </Provider>
  );
}
